$(document).ready(function(){
  $('.slider-nav').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: false,
    centerMode: true,
    arrows: true,
    variableWidth: true,
    autoplay: true,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480, 
        settings: {
          slidesToShow: 1,
        }
      }
    ],
    autoplaySpeed: 4000,
    focusOnSelect: true,
    prevArrow: '<button type="button" class="slick-prev"><img src="https://cdn.shopify.com/s/files/1/0459/1976/4632/files/left-arrow.svg?v=1769750781" alt="Previous"></button>',
    nextArrow: '<button type="button" class="slick-next"><img src="https://cdn.shopify.com/s/files/1/0459/1976/4632/files/right-arrow.svg?v=1769750806" alt="Next"></button>'
  });
});

/* === Swee Choon CTA White Hover Fix === */
/* Injects a style tag at the END of body after full load - wins cascade over any inline styles */
(function(){
  function injectWhiteHoverStyle(){
    var s=document.createElement('style');
    s.id='sc-hover-fix';
    s.textContent='.sc-dark-cta .sc-btn-whatsapp:hover{background:#FFFFFF!important;background-color:#FFFFFF!important;color:#25D366!important;border-color:#25D366!important;}.sc-dark-cta .sc-btn-whatsapp:hover span{color:#25D366!important;}';
    document.body.appendChild(s);
  }
  if(document.readyState==='complete'){
    injectWhiteHoverStyle();
  }else{
    window.addEventListener('load',injectWhiteHoverStyle);
  }
})();
